<div
  class="card-bg w-full mx-auto flex flex-col gap-6 text-[#141437] dark:text-ink-soft p-6 rounded-xl overflow-visible">
  <!-- Header Section — Collapsing & Sliding pattern  -->
  <div #headerSentinel aria-hidden="true" class="dashboard-header__sentinel -mt-px h-px w-px pointer-events-none"></div>

  <!-- Sticky: sticky header -->
  <header
    class="dashboard-header sticky top-0 z-999999 -mx-6 -mt-6 px-6 bg-white dark:bg-surface-1 backdrop-blur-md border-b border-[rgba(234,234,234,1)] dark:border-line items-center"
    [class.is-collapsed]="headerCollapsed()">

    <div class="dashboard-header__title flex flex-col">
      <div class="flex items-center gap-3">
        <h1
          class="dashboard-header__title-text font-bold tracking-tight text-[#141437] dark:text-white flex items-center gap-3">
          {{ currentView() === 'reports' ? 'My Dashboards' : 'Customized Dashboard' }}
        </h1>
      </div>
      <p class="dashboard-header__desc text-[#7D7D93] dark:text-ink-muted text-sm">
        <span>
          {{ currentView() === 'reports' ? 'Access your personalized dashboard reports and analytics.' : 'Customize your
          workspace and manage analytics widgets.' }}
        </span>
      </p>
    </div>

    <div class="dashboard-header__controls flex flex-wrap items-center gap-3 lg:gap-4 justify-start lg:justify-end">
      <div class="relative group ">
        <div
          class="backdrop-blur-xl border shadow-sm dark:shadow-2xl hover:bg-slate-50 dark:hover:bg-white/10 px-5 py-3 rounded-2xl text-sm font-medium transition-all flex items-center gap-2 gap-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20 self-start sm:self-auto">
          <app-icon name="activity" [size]="13"></app-icon>
          Total {{ unifiedTiles().length === 1 ? 'Widget' : 'Widgets' }} : {{ unifiedTiles().length }}
        </div>
      </div>

      @if (hasDashboardData() && unifiedTiles().length > 0) {
      <!-- 🔹 datepicker for custom dashboard cards wise data change accroding to there actual response.
           Kept mounted across `layoutLoading` transitions and seeded with the
           saved `[value]` so the user's selection (e.g. "Last 90 Days") is not
           silently reset to the picker's hard-coded default when a card is
           deleted and the dashboard reloads. -->
      <app-date-picker [size]="'md'" [showComparison]="true" [allowComparison]="true" [showGroupBy]="true"
        [value]="currentDatePickerValue()" (dateRangeChange)="onDashboardDateRangeChange($event)"
        (onApply)="onDashboardDateRangeChange($event)">
      </app-date-picker>

      <button (click)="setCardsView()" [disabled]="layoutLoading()"
        class=" cursor-pointer bg-white dark:bg-surface-1 border border-[rgba(234,234,234,1)] dark:border-line shadow-sm dark:shadow-2xl hover:bg-slate-50 dark:hover:bg-line px-5 py-3 rounded-2xl text-sm font-medium transition-all flex items-center gap-2 text-[#141437] dark:text-white disabled:opacity-60 disabled:cursor-not-allowed">
        <app-icon name="settings" [size]="18"></app-icon>
        Edit Your Settings
      </button>
      }

    </div>
  </header>

  <div class="flex flex-col gap-10 animate-in fade-in slide-in-from-bottom-4 duration-500">
    @if (layoutLoading()) {
    <div class="flex items-center justify-center py-20">
      <!-- overall page loader while dashboard is loading -->
      <app-individual-toaster hidden></app-individual-toaster>
    </div>
    } @else if (unifiedTiles().length > 0) {
    <section class="relative animate-in fade-in slide-in-from-bottom-2 duration-700">
      <div class="relative bg-transparent overflow-visible transition-all duration-500 flex flex-col gap-6">
        <div class="report-embed grid grid-cols-12 gap-4 grid-flow-row-dense items-stretch" cdkDropList
          cdkDropListOrientation="mixed" [cdkDropListDisabled]="true" [cdkDropListData]="unifiedTiles()"
          (cdkDropListDropped)="onUnifiedDrop($event)">
          @for (tile of unifiedTiles(); track trackUnifiedTile($index, tile)) {
          <div cdkDrag [cdkDragData]="tile" [ngClass]="getWidgetColClass(tile)"
            [class.training-status-fit]="tile.id === 'mr2_training_status'" [class.is-black-card]="isBlackCard(tile)"
            [class]="'unified-tile group h-full relative rounded-2xl border border-[rgba(234,234,234,1)] dark:border-line-strong shadow-sm transition-all duration-300 hover:shadow-md dark:hover:shadow-[0_10px_30px_-10px_rgba(173,70,255,0.35)] overflow-visible ' + tile.id">
            <div *cdkDragPlaceholder [ngClass]="getWidgetColClass(tile)"
              class="rounded-2xl border-2 border-dashed border-blue-400/60 bg-blue-50/40 dark:bg-blue-500/10 min-h-[220px]">
            </div>
            <app-widget-host [tile]="tile" [embeddedColSpan]="resolveTileColSpan(tile)"
              (instanceReady)="onWidgetInstanceReady(tile, $event)">
            </app-widget-host>
          </div>
          }
        </div>
      </div>
    </section>
    } @else {
    <!-- empty state for existing user if there is no cards or data -->
    @if (searchQuery().trim().length > 0) {
    <!-- Search-driven empty state -->
    <div
      class="card-bg col-span-full rounded-[40px] p-20 flex flex-col items-center justify-center text-center gap-6 border-dashed">
      <div
        class="w-24 h-24 rounded-xl bg-blue-500/10 flex items-center justify-center text-blue-500 dark:text-blue-400 mb-2">
        <app-icon name="search" [size]="48"></app-icon>
      </div>
      <div class="flex flex-col gap-2">
        <h3 class="text-2xl font-bold text-[#141437] dark:text-white">No widgets found</h3>
        <p class="text-[#7D7D93] dark:text-ink-muted max-w-md mx-auto">We couldn't find any visible widgets matching "{{
          searchQuery() }}". Try adjusting your search.</p>
      </div>
      <button (click)="searchQuery.set('')"
        class="text-blue-500 font-medium hover:text-blue-400 transition-colors">Clear search</button>
    </div>
    } @else {
    <!-- New-user empty dashboard state (no visible widgets configured yet) -->
    <div class="card-bg col-span-full rounded-xl p-6 lg:p-10">
      <div
        class="border-2 border-dashed border-[rgba(234,234,234,1)] dark:border-line rounded-3xl p-16 flex flex-col items-center justify-center text-center gap-4">
        <div class="grid grid-cols-2 gap-1.5 mb-2 text-slate-300 dark:text-line">
          <div class="w-4 h-4 rounded-[3px] border-2 border-current"></div>
          <div class="w-4 h-4 rounded-[3px] border-2 border-current"></div>
          <div class="w-4 h-4 rounded-[3px] border-2 border-current"></div>
          <div class="w-4 h-4 rounded-[3px] border-2 border-current"></div>
        </div>
        <h3 class="text-lg font-semibold text-[#141437] dark:text-white">Your dashboard is empty</h3>
        <p class="text-[#7D7D93] dark:text-ink-muted text-sm max-w-md">
          Open any report page (like <span class="font-medium text-[#38385B] dark:text-ink-soft">Monthly Report
            1</span>, <span class="font-medium text-[#38385B] dark:text-ink-soft">Monthly Report 2</span>, etc.) from
          the sidebar and click <span class="font-medium text-blue-600 dark:text-blue-400">"Add to My Dashboard"</span>
          on the widgets you want to display here.
        </p>
      </div>
    </div>
    }
    }
  </div>

</div>